/*
Author : Raphaël Dardeau


Markup : 

<a href="" data-triggering="click" data-triggering-target="body" data-triggering-class="is-navigating">
    link
</a>


Setup : 

$(function() {
    $("[data-triggering]").triggering();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "triggering",
        defaults = {
        triggerEvent: 'click',
        triggerClassOn: "is-on",
        targetClassOn: "is-on",
        mouseoverTimeout: 200,
        activate:false,
        after: function(/*isOn*/) {}
    };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            var _this = this;
            var settings = this.settings;
            $(this.element).each(function () {
                var trigger = $(this);
                var event = trigger.data("triggering") || settings.triggerEvent;
                var target = (trigger.data("triggering-target")) ? $(trigger.data("triggering-target")) : trigger;
                var triggerClassOn = (trigger.data("triggering-target")) ? settings.triggerClassOn : '';
                var targetClassOn = (trigger.data("triggering-class")) ? trigger.data("triggering-class") : settings.targetClassOn;
                var targetClearClass = (trigger.data("triggering-clearclass")) ? trigger.data("triggering-clearclass") : false;
                var activate = (trigger.data("triggering-activate")) ? true : settings.activate;
                var focus = (trigger.data("triggering-focus")) ? $(trigger.data("triggering-focus")) : false;

                if (trigger.data("triggering-clearclass"))
                    targetClassOn = trigger.data("triggering-clearclass");

                var params = {
                    trigger: trigger,
                    triggerClassOn: triggerClassOn,
                    target: target,
                    targetClassOn: targetClassOn,
                    after: settings.after,
                    focus: focus
                };

                if (activate) 
                    _this.triggerOn(params);

                switch (event) {
                    case "click":
                        $(trigger).on("click", function (e) {
                            if (!$(target).hasClass(targetClassOn) && !trigger.data("triggering-clearclass"))
                                _this.triggerOn(params);
                            else
                                _this.triggerOff(params);
                            if ($(trigger).prop("tagName") == 'A' && !$(trigger).attr('href')) e.preventDefault();
                        });
                    break;
                    case "focus":
                        $(trigger).on("focus", function () {
                            if (trigger.data("triggering-clearclass")) 
                                _this.triggerOff(params);
                            else
                                _this.triggerOn(params);
                        }).on("blur", function () {
                            _this.triggerOff(params);
                        });
                    break;
                    case "hover":
                        $(trigger).on("mouseenter", function () {
                            if (trigger.data("triggering-clearclass")) 
                                _this.triggerOff(params);
                            else {
                                $(trigger).data("hover", true);
                                setTimeout(function () {
                                    if ($(trigger).data("hover"))
                                        _this.triggerOn(params);
                                }, settings.mouseoverTimeout);
                            }
                        }).on("mouseleave", function () {
                            $(trigger).removeData("hover");
                            setTimeout(function () {
                                if (!$(trigger).data("hover"))
                                    _this.triggerOff(params);
                            }, settings.mouseoverTimeout);
                        });
                        if (trigger.data("triggering-target")) {
                            $(target).on("mouseenter", function () {
                                $(trigger).data("hover", true);
                            }).on("mouseleave", function () {
                                $(trigger).trigger("mouseleave");
                            });
                        }
                    break;
                    case "touch":
                        if ('ontouchstart' in window || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
                            var touchStartX = 0, 
                                touchEndX = 0,
                                touchStartY = 0, 
                                touchEndY = 0,
                                touchRatio = screen.width * 0.25;
                            $(trigger).on("touchstart", function (e) {
                                touchStartX = e.originalEvent.touches[0].pageX;
                                touchStartY = e.originalEvent.touches[0].pageY;
                            }).on("touchmove", function (e) {
                                touchEndX = e.originalEvent.touches[0].pageX;
                                touchEndY = e.originalEvent.touches[0].pageY;
                                if (touchEndX - touchStartX >= touchRatio && touchStartX <= 50) {
                                    _this.triggerOn(params);
                                    touchStartX = touchEndX;
                                } else if (touchStartX - touchEndX >= touchRatio && target.hasClass(targetClassOn)) {
                                    _this.triggerOff(params);
                                    touchStartX = touchEndX;
                                } else if (target.hasClass(targetClassOn) && Math.abs(touchStartY - touchEndY) < 100) {
                                    e.preventDefault();
                                }
                            });
                        }
                    break;
                }
            });
        },
        triggerOn: function (params) {
            if (params.triggerClassOn)
                $(params.trigger).addClass(params.triggerClassOn);
            if (params.targetClassOn.indexOf(',') != -1) {
                var classArr = params.targetClassOn.split(',');
                for (var i in classArr) {
                    $(params.target).addClass(classArr[i]);
                }
            } else
                $(params.target).addClass(params.targetClassOn);
            if (params.focus)
                $(params.focus).attr("tabindex", 0).trigger("focus");
            params.after(true);
        },
        triggerOff: function (params) {
            if (params.triggerClassOn)
                $(params.trigger).removeClass(params.triggerClassOn);
            if (params.targetClassOn.indexOf(',') != -1) {
                var classArr = params.targetClassOn.split(',');
                for (var i in classArr) {
                    $(params.target).removeClass(classArr[i]);
                }
            } else
                $(params.target).removeClass(params.targetClassOn);
            if (params.focus)
                $(params.focus).removeAttr("tabindex");
            params.after(false);
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);